// ==========================================
// 1. PROMOTION CONFIGURATION (Easy to switch)
// ==========================================
const PROMO_CONFIG = {
  steps: [
    { 
      id: 'strap', 
      navTitle: 'Straps', 
      headerTitle: 'SELECT 2 FREE STRAPS', 
      limit: 2, 
      dataKey: 'merged_straps' 
    }
    ,
    { 
      id: 'purse', 
      navTitle: 'Coin purse', 
      headerTitle: 'SELECT 1 FREE COIN PURSE', 
      limit: 1, 
      dataKey: 'merged_purses' 
    }
  ]
};

// ==========================================
// 2. GLOBAL STATE & DATA FETCHING
// ==========================================
window.modalData = {
  merged_straps: [],
  merged_purses: []
};
let userSelections = {}; 
let currentStepIndex = 0;

// Utility to merge arrays and remove duplicates (keeps featured first)
function deduplicateAndMerge(featuredArray, allArray) {
  const seen = new Set();
  const merged = [];
  
  [...(featuredArray || []), ...(allArray || [])].forEach(item => {
    if (!seen.has(item.id)) {
      seen.add(item.id);
      merged.push(item);
    }
  });
  return merged;
}

async function fetchStrapData(handle) {
  try {
    const url = handle ? `/products/${handle}?sections=cart-straps` : `${window.location.pathname}?sections=cart-straps`;
    const response = await fetch(url);
    const data = await response.json();

    const parser = new DOMParser();
    const doc = parser.parseFromString(data['cart-straps'], 'text/html');
    const jsonScript = doc.getElementById('strap-upsell-data');

    if (jsonScript) {
      const rawData = JSON.parse(jsonScript.textContent);
      
      // Merge featured + all, keeping featured at the top
      window.modalData.merged_straps = deduplicateAndMerge(rawData.featured_straps, rawData.all_straps);
      window.modalData.merged_purses = deduplicateAndMerge(rawData.featured_purses, rawData.all_purses);

      if (window.modalData.merged_straps.length === 0) {
        fallbackToCart();
      } else {
        openDynamicModal(); 
      }
    } else {
      console.error("Could not find JSON in the returned section.");
      fallbackToCart();
    }
  } catch (error) {
    console.error("Error fetching modal data:", error);
    fallbackToCart();
  }
}

function fallbackToCart() {
  if (typeof theme !== 'undefined' && theme.CartDrawer) {
    var cart = new theme.CartDrawer;
    if(cart.init) cart.init();
    if(cart.open) cart.open(); 
  }
}

// ==========================================
// 3. DYNAMIC DOM GENERATION (SCROLL SAFE)
// ==========================================
function buildModalDOM() {
  const existingModal = document.querySelector('.strap-modal-container');
  if (existingModal) existingModal.remove();

  // Hide breadcrumbs entirely if there is only 1 step
  const isSingleStepPromo = PROMO_CONFIG.steps.length === 1;
  
  const breadcrumbsHTML = PROMO_CONFIG.steps.map((step, index) => {
    const isFirst = index === 0;
    return `<span id="indicator-${step.id}" style="opacity: ${isFirst ? '1' : '0.5'}; text-decoration: ${isFirst ? 'underline' : 'none'}; transition: opacity 0.2s;">Step ${index + 1}: ${step.navTitle}</span>`;
  }).join(' &rsaquo; ');

  const breadcrumbsContainer = isSingleStepPromo ? '' : `
    <div class="modal-step-indicator" style="text-align: center; margin-bottom: 15px; font-size: 14px; font-weight: bold; text-transform: uppercase;">
      ${breadcrumbsHTML}
    </div>
  `;

  // Build Step UI elements (FLAT STRUCTURE FOR SCROLLING)
  const stepsHTML = PROMO_CONFIG.steps.map((step, index) => {
    const isFirst = index === 0;
    const isLast = index === PROMO_CONFIG.steps.length - 1;
    const displayStyle = isFirst ? '' : 'display: none;';
    const uiClass = `step-ui-${index}`; 
    const itemsData = window.modalData[step.dataKey];
    
    // Build Grid Items
    const gridItems = itemsData.map(item => `
      <div class="strap-item">
        <img src="${item.image}" alt="${item.title}">
        <span class="strap-label">${item.title}</span>
        <button class="select-btn btn btn--full btn--secondary" data-id="${item.id}" data-step-id="${step.id}" data-limit="${step.limit}">SELECT</button>
      </div>
    `).join('');

    // --- FIX: Button Layout Logic ---
    let footerButtons = '';
    if (isFirst && isLast) {
      // Single step: Show Add to Cart AND Choose For Me
      footerButtons = `
        <button id="btn-submit" class="btn btn--full atc-main-btn" disabled>ADD TO CART</button>
        <button type="button" class="btn btn--full" id="btn-auto-choose"><span>Choose for me</span></button>
      `;
    } else if (isFirst) {
      // First step of multi-step: Show Next AND Choose For Me
      footerButtons = `
        <button id="btn-next-${step.id}" class="btn btn--full atc-main-btn step-nav-btn" data-target="${index + 1}" disabled>NEXT: ${PROMO_CONFIG.steps[index + 1].navTitle.toUpperCase()}</button>
        <button type="button" class="btn btn--full" id="btn-auto-choose"><span>Choose for me</span></button>
      `;
    } else if (isLast) {
      // Last step of multi-step
      footerButtons = `
        <button class="btn btn--secondary step-nav-btn" data-target="${index - 1}" style="flex: 1; min-width: 100px;">&larr; BACK</button>
        <button id="btn-submit" class="btn btn--full atc-main-btn" style="flex: 2;" disabled>ADD TO CART</button>
      `;
    } else {
      // Middle steps (if > 2 steps)
      footerButtons = `
        <button class="btn btn--secondary step-nav-btn" data-target="${index - 1}" style="flex: 1;">&larr; BACK</button>
        <button id="btn-next-${step.id}" class="btn btn--full atc-main-btn step-nav-btn" data-target="${index + 1}" style="flex: 2;" disabled>NEXT: ${PROMO_CONFIG.steps[index + 1].navTitle.toUpperCase()}</button>
      `;
    }

    // Notice we only use flex-wrap gap on Step 2+ so the BACK and NEXT buttons sit side-by-side
    return `
      <div class="modal-header ${uiClass}" style="${displayStyle}">
        <h2 class="modal-title">${step.headerTitle}</h2>
        <span class="pill" id="counter-${step.id}">0/${step.limit} Selected</span>
      </div>
      <div class="strap-grid ${uiClass}" style="${displayStyle}">
        ${gridItems}
      </div>
      <div class="modal-footer ${uiClass}" style="${displayStyle} ${(index > 0) ? 'flex-wrap: wrap; gap: 10px;' : ''}">
        ${footerButtons}
      </div>
    `;
  }).join('');

  const modalHTML = `
    <div class="strap-modal-container">
      <div id="strap-modal" class="modal-overlay model-visible">
        <div class="modal-content">
          <span class="close-modal">&times;</span>
          ${breadcrumbsContainer}
          ${stepsHTML}
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);
  attachModalEvents();
}

// ==========================================
// 4. MODAL LOGIC & EVENTS
// ==========================================
function openDynamicModal() {
  userSelections = {};
  PROMO_CONFIG.steps.forEach(step => userSelections[step.id] = []);
  currentStepIndex = 0;
  
  buildModalDOM();
}

function attachModalEvents() {
  // Close buttons
  document.querySelector('.close-modal')?.addEventListener('click', closeModal);
  document.querySelector('#strap-modal')?.addEventListener('click', (e) => {
    if (e.target.id === 'strap-modal') closeModal();
  });

  // Step Navigation Buttons (Next / Back)
  document.querySelectorAll('.step-nav-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      goToStep(parseInt(btn.getAttribute('data-target')));
    });
  });

  // Auto Choose Button
  document.getElementById('btn-auto-choose')?.addEventListener('click', function(e) {
    e.preventDefault();
    this.classList.add('btn--loading');
    submitAutoSelections();
  });

  // Final Submit Button
  document.getElementById('btn-submit')?.addEventListener('click', function(e) {
    e.preventDefault();
    this.classList.add('btn--loading');
    submitManualSelections();
  });

  // Selection Buttons inside Grids
  document.querySelectorAll('.select-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const id = this.getAttribute('data-id');
      const stepId = this.getAttribute('data-step-id');
      const limit = parseInt(this.getAttribute('data-limit'));
      
      const arr = userSelections[stepId];
      
      if (arr.includes(id)) {
        // Deselect
        arr.splice(arr.indexOf(id), 1);
        this.classList.remove('selected');
        this.innerText = 'SELECT';
      } else if (arr.length < limit) {
        // Select
        arr.push(id);
        this.classList.add('selected');
        this.innerText = 'SELECTED';
      }
      
      updateStepUI(stepId, limit);
    });
  });
}

function goToStep(targetIndex) {
  // Hide all UI pieces securely
  PROMO_CONFIG.steps.forEach((step, i) => {
    document.querySelectorAll(`.step-ui-${i}`).forEach(el => el.style.display = 'none');
    
    const ind = document.getElementById(`indicator-${step.id}`);
    if(ind) {
      ind.style.opacity = '0.5';
      ind.style.textDecoration = 'none';
    }
  });

  // Show target UI pieces
  document.querySelectorAll(`.step-ui-${targetIndex}`).forEach(el => el.style.display = ''); 
  
  const targetStep = PROMO_CONFIG.steps[targetIndex];
  const targetInd = document.getElementById(`indicator-${targetStep.id}`);
  if (targetInd) {
    targetInd.style.opacity = '1';
    targetInd.style.textDecoration = 'underline';
  }
  
  currentStepIndex = targetIndex;
}

function updateStepUI(stepId, limit) {
  const count = userSelections[stepId].length;
  
  // Update Counter Pill
  const counterPill = document.getElementById(`counter-${stepId}`);
  if (counterPill) counterPill.innerText = `${count}/${limit} Selected`;

  // Determine if we need to unlock "Next" or "Add to Cart"
  const stepIndex = PROMO_CONFIG.steps.findIndex(s => s.id === stepId);
  const isLast = stepIndex === PROMO_CONFIG.steps.length - 1;
  
  if (isLast) {
    const submitBtn = document.getElementById('btn-submit');
    if (submitBtn) submitBtn.disabled = (count < limit);
  } else {
    const nextBtn = document.getElementById(`btn-next-${stepId}`);
    if (nextBtn) {
      if (count === limit) {
        nextBtn.disabled = false;
        nextBtn.innerText = `NEXT: ${PROMO_CONFIG.steps[stepIndex + 1].navTitle.toUpperCase()}`;
      } else {
        nextBtn.disabled = true;
        nextBtn.innerText = `SELECT ${limit - count} MORE ${PROMO_CONFIG.steps[stepIndex].navTitle.toUpperCase()}`;
      }
    }
  }
}

function closeModal() {
  document.querySelector('.strap-modal-container')?.remove();
  fallbackToCart();
}

// ==========================================
// 5. CART SUBMISSIONS
// ==========================================
function submitManualSelections() {
  const allSelectedIds = Object.values(userSelections).flat();
  const items = allSelectedIds.map(id => ({ id: parseInt(id), quantity: 1 }));
  
  processCartAdd(items);
}

function submitAutoSelections() {
  const items = [];
  PROMO_CONFIG.steps.forEach(step => {
    const dataArray = window.modalData[step.dataKey];
    const topPicks = dataArray.slice(0, step.limit);
    topPicks.forEach(item => {
      items.push({ id: parseInt(item.id), quantity: 1 });
    });
  });
  
  processCartAdd(items);
}

function processCartAdd(itemsArray) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: itemsArray })
  })
  .then(res => res.json())
  .then(() => {
    closeModal();
  })
  .catch(err => {
    console.error("Cart Error:", err);
    closeModal();
  });
}

// ==========================================
// 6. MAIN PRODUCT ADD TO CART TRIGGERS
// ==========================================
document.querySelectorAll('[data-new-atc], [data-sticky-atc]').forEach(button => {
  button.addEventListener('click', async function(e) {
    e.preventDefault(); 
    const btn = this;
    const mainVariantId = this.getAttribute('data-variant-id');
    const freeGiftId = btn.getAttribute('data-free-gift-id');
    const productHandle = btn.getAttribute('data-product-handle') || null;

    if (!mainVariantId) return console.error("Variant ID missing");

    btn.classList.add('btn--loading');
    this.style.pointerEvents = 'none';

    try {
        let items = [{ id: parseInt(mainVariantId), quantity: 1 }];

        if (freeGiftId) {
          const cartRes = await fetch( window.Shopify.routes.root + '/cart.js');
          const cart = await cartRes.json();
          const giftAlreadyInCart = cart.items.some(item => item.id === parseInt(freeGiftId));

          if (!giftAlreadyInCart) {
            items.push({ id: parseInt(freeGiftId), quantity: 1 });
          }
        }

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        
        await fetchStrapData(productHandle);

    } catch (error) {
        console.error('Error:', error);
    } finally {
        btn.classList.remove('btn--loading');
        btn.style.pointerEvents = 'auto';
    }
  });
});

// ==========================================
// 7. PROMO BANNER INJECTION
// ==========================================
const targetElement = document.querySelector('[data-new-atc]');
const textEl = document.querySelector('#AnnouncementSlider');

if (targetElement && textEl) {
  const text = textEl.innerText;
  const match = text.match(/WORTH\s+([^\s]+)/i);
  let worthString = match ? ` WORTH ${match[1]}` : "";

  const promoBanner = `
  <section class="atc-promo-banner">
    <div class="atc-inner-container">
      <h2>2 Free Strap, Keyring & Coin purse worth${worthString}</h2>
      <ol>
        <li>Choose your bag</li>
        <li>Choose any 2 straps <a href="${window.Shopify.routes.root }collections/straps">HERE</a></li>
        <li>Choose a <a href="${window.Shopify.routes.root }collections/shopping-totes">Shopping Totes</a> of your choice</li>
        <li>DISCOUNT AUTOMATICALLY APPLIED AT CHECKOUT</li>
      </ol>
    </div>
  </section>
  `;
  targetElement.insertAdjacentHTML('beforebegin', promoBanner);
}

// ==========================================
// 8. CART PAGE VALIDATION (REGEX UPDATED)
// ==========================================
async function checkCartForMissingGifts() {
  if (window.location.pathname !== '/cart') return;

  try {
    const cartRes = await fetch(window.Shopify.routes.root + '/cart.js');
    const cart = await cartRes.json();

    if (cart.items.length === 0) return;

    // 1. Regex to check if it's a Bag, but exclude specific styles
    const qualifyingBags = cart.items.filter(item => {
      const isBag = /\bbag(s)?\b/i.test(item.product_type) || /\bbag(s)?\b/i.test(item.title);
      
      // Exclude Strand, Pelham, Travel, Weekend, and Lulworth
      const excludeRegex = /\b(strand|pelham|travel|weekend|lulworth)\b/i;
      const isExcluded = excludeRegex.test(item.title) || excludeRegex.test(item.handle);
      
      return isBag && !isExcluded;
    });
    if (qualifyingBags.length == 0) return; 

    const mainBagHandle = qualifyingBags[0].handle;

    // 2. Regex to count existing Straps and Purses in cart
    let existingStrapsCount = 0;
    let existingPursesCount = 0;


    cart.items.forEach(item => {
      if (item.final_price === 0) {
        // Match "strap" or "straps"
        if (/\bstrap(s)?\b/i.test(item.title) || /\bstrap(s)?\b/i.test(item.title)) {
          existingStrapsCount += item.quantity;
        }
        // Match "purse" or "purses" (covers "coin purse" as well)
        if (/\bpurse(s)?\b/i.test(item.title) || /\bpurse(s)?\b/i.test(item.title)) {
          existingPursesCount += item.quantity;
        }
      }
    });

    // 3. Read dynamically from your PROMO_CONFIG
    const strapConfig = PROMO_CONFIG.steps.find(s => s.id === 'strap');
    const purseConfig = PROMO_CONFIG.steps.find(s => s.id === 'purse');
    
    const requiredStraps = strapConfig ? strapConfig.limit : 0;
    const requiredPurses = purseConfig ? purseConfig.limit : 0;

    console.log(`Straps: ${existingStrapsCount}/${requiredStraps} | Purses: ${existingPursesCount}/${requiredPurses}`);

    // 4. Trigger Modal if missing items
    if (existingStrapsCount < requiredStraps || existingPursesCount < requiredPurses) {
      console.log("Missing free gifts detected. Opening modal...");
      await fetchStrapData(mainBagHandle);
    }

  } catch (error) {
    alert('ERROR')
    console.error("Error validating cart gifts:", error);
  }
}
document.addEventListener('DOMContentLoaded', checkCartForMissingGifts);